<script setup>

const { locale } = useI18n()

const licenceFormUI = await useUIFetch(locale.value, 'form/license')

const nameField = licenceFormUI.body.find(item => item.name === 'name')
const emailField = licenceFormUI.body.find(item => item.type === 'Email')
const artistField = licenceFormUI.body.find(item => item.name === 'artist')
const projectField = licenceFormUI.body.find(item => item.name === 'project')
const submitField = licenceFormUI.body.find(item => item.name === '_submit')

const licenseForm = ref(null)
const isSubmitting = ref(false)

const success = ref(null)

const submitHandler = async (value) => {
	isSubmitting.value = true

	const formData = new FormData()
	formData.append('name', value.name)
	formData.append('email', value.email)
	formData.append('artist', value.artist)
	formData.append('project', value.project)
	formData.append('_submit', licenceFormUI.body.find(item => item.name === '_submit').value)
	formData.append('_do', 'LicenseForm-submit')

	const response = await useFormPost(locale.value, 'form/license', {
		method: 'post',
		body: formData,
	})

	if(response.success) {
		success.value = response.success_message
	}
}

</script>

<template>
	<div>
		<FormKit
			v-if="!success"
			ref="licenseForm"
			type="form"
			:actions="false"
			@submit="submitHandler"
		>
			<div class="w-full">
				<div class="w-full mb-5">
					<FormKit
						class="mb-7"
						type="text"
						name="name"
						id="name"
						:placeholder="nameField?.label"
						validation="required"
						:validation-messages="{
							required: nameField?.validator.filled,
						}"
					/>
				</div>
				<div class="w-full mb-5">
					<FormKit
						class="mb-7"
						type="email"
						name="email"
						id="email"
						:placeholder="emailField?.label"
						validation="required|email"
						:validation-messages="{
							required: emailField?.validator.filled,
							email: emailField?.validator.valid,
						}"
					/>
				</div>
				<div class="w-full mb-5">
					<FormKit
						class="mb-7"
						type="text"
						name="artist"
						id="artist"
						:placeholder="artistField?.label"
						validation="required"
						:validation-messages="{
							required: artistField?.validator.filled,
						}"
					/>
				</div>
				<div class="w-full mb-5">
					<FormKit
						class="mb-7"
						type="text"
						name="project"
						id="project"
						:placeholder="projectField?.label"
						validation="required"
						:validation-messages="{
							required: projectField?.validator.filled,
						}"
					/>
				</div>
				<div>
					<FormKit
						type="submit"
						:classes="{
							input: `green w-auto`,
						}"
					>
						<span>{{submitField?.label}}</span>
					</FormKit>
				</div>
			</div>
		</FormKit>
		<h5 v-else class="text-green">{{ success }}</h5>
	</div>
</template>